import { render, staticRenderFns } from "./MostraMensagemValidacao.vue?vue&type=template&id=083b5455"
import script from "./MostraMensagemValidacao.vue?vue&type=script&lang=js"
export * from "./MostraMensagemValidacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports